import { getCookie } from 'utilities';
import { 
  addEventListeners,
  createImpactSessionCookie,
  tryPopulateEmail,
} from './helpers';
import * as robots from 'events/robots_events';
import * as trackingService from 'events/tracking_service_events';

export default class AnalyticsService {
  initialize() {
    window.BPFTracking = {
      createPageVisitRecord: trackingService.sendPageVisit,
      sendEvent: robots.sendEvent,
      cookiesSet: (getCookie('pid') != null) && (getCookie('sid') != null),
      terminatingEventSent: false,
    }

    tryPopulateEmail();
    window.BPFTracking.createPageVisitRecord();

    createImpactSessionCookie();
    addEventListeners();
  }
}
